import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model"

export class UpdateExpedienteNotaRequest extends UpdateKeyValueRequest {
  public idExpediente!: number
  public idUsuario!: number
}
